"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var formatters = {
  /**
   * For example, XXXX XXXX XXXX XXXX
   * @param {string}intStr
   * @param {string} splitter
   * @return {string}
   */
  full: function full(intStr) {
    var splitter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return this._addSplitter(intStr, splitter);
  },
  card: function card(intStr) {
    var splitter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
    return this._addSplitter(intStr, splitter);
  },

  /**
   * For example, XXXX **** **** XXXX
   * @param {string} intStr
   * @param {string} splitter
   * @return {string}
   */
  hidden: function hidden(intStr) {
    var splitter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '*';
    var hidden = '',
        i,
        start,
        tail; // too short number

    if (intStr.length <= this.countBeforeSplitter * 2) {
      i = 8; // rest of numbers

      tail = intStr.length > this.countBeforeSplitter ? intStr.substr((intStr.length - this.countBeforeSplitter) * -1) : '';
    } else {
      i = intStr.length - this.countBeforeSplitter * 2;
      tail = intStr.substr(this.countBeforeSplitter * -1);
    }

    while (i--) {
      hidden += '*';
    }

    start = intStr.substr(0, this.countBeforeSplitter);
    return this._addSplitter(start + hidden + tail, splitter);
  },

  /**
   * For example, ** XXXX
   * @param {string} intStr
   * @param {string} splitter
   * @return {string}
   */
  "short": function short(intStr) {
    var splitter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '*';

    if (intStr.length < this.countBeforeSplitter * 2) {
      return splitter + ' ' + intStr.substr(this.countBeforeSplitter / 2 * -1);
    } else {
      return splitter + ' ' + intStr.substr(this.countBeforeSplitter * -1);
    }
  }
};
/**
 * @description Bank Accounts Parser, use:a = new IAccount('1234 12 34 12341234')
 * @constructor
 * @param {number|string} value
 * @return {object}
 */

var IAccount =
/*#__PURE__*/
function () {
  function IAccount(value) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, IAccount);
    this.value = null;
    this.countBeforeSplitter = options.countBeforeSplitter || 4;

    if (!value) {
      return this;
    }

    if (value instanceof IAccount) {
      this.value = value.value;
    } else {
      if (typeof value === 'number') {
        this.value = value.toString();
      } else if (typeof value === 'string') {
        this.value = value.replace(/[\D]/g, '');
      }
    }
  }
  /**
   * @description Get string like '1234123412341234'
   * @param {string} format "full"|"short"
   * @param {string} splitter
   * @return {string}
   */


  (0, _createClass2["default"])(IAccount, [{
    key: "toString",
    value: function toString() {
      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'full';
      var splitter = arguments.length > 1 ? arguments[1] : undefined;
      var str;
      splitter = splitter === null ? '' : splitter;
      str = this.value || '';

      if (this.value) {
        if (format === 'full') {
          str = formatters.full.call(this, this.value, splitter);
        } else if (format === 'short' && this.value) {
          str = formatters["short"].call(this, this.value, splitter);
        } else if (format === 'hidden' && this.value) {
          str = formatters.hidden.call(this, this.value, splitter);
        } else if (format === 'card') {
          str = formatters.card.call(this, this.value, splitter);
        }
      }

      return str;
    }
    /**
     * @description Check on Luhn algorithm
     * @return {Boolean}
     */

  }, {
    key: "isCard",
    value: function isCard() {
      return this.luhnValidate();
    }
    /**
     * check card's type on Visa
     * @return {Boolean}
     */

  }, {
    key: "isVisa",
    value: function isVisa() {
      return !!(this.value && +this.value.substr(0, 1) === 4 && [13, 16, 17, 18, 19].indexOf(this.value.length) >= 0);
    }
    /**
     * check card's type on MasterCard
     * @return {Boolean}
     */

  }, {
    key: "isMasterCard",
    value: function isMasterCard() {
      return !!(this.value && [5, 6].indexOf(+this.value.substr(0, 1)) >= 0 && this.value.length >= 16 && this.value.length <= 19);
    }
    /**
     * bank account matching
     * @return {Boolean}
     */

  }, {
    key: "isAccount",
    value: function isAccount() {
      return this.value && this.value.length >= 6 && this.value.length <= 19;
    }
    /**
     * Check account
     * @param {string} format
     * @return {boolean}
     */

  }, {
    key: "validate",
    value: function validate(format) {
      if (!this.value || this.value.length < 4) {
        return false;
      }

      if (format === 'luhn') {
        return this.isCard();
      } else {
        /**
         * If this is not a card and not Visa or Mastercard, detected as account
         */
        if (!this.isCard() && (this.isVisa() || this.isMasterCard()) && this.isAccount() || !this.isAccount()) {
          return false;
        }
      }

      return true;
    }
    /**
     *
     * @param {object} number
     * @return {Boolean}
     * @private
     */

  }, {
    key: "luhnValidate",
    value: function luhnValidate() {
      var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.value;
      number = number || '';
      var len = number.length,
          digit = parseInt(number.substring(len - 1, len)),
          less = number.substring(0, len - 1);
      return this._luhnCalculate(less) === parseInt(digit);
    }
    /**
     * Javascript code copyright 2009 by Fiach Reid : www.webtropy.com
     * @param {string} str
     * @return {boolean}
     */

  }, {
    key: "_luhnCalculate",
    value: function _luhnCalculate() {
      var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var sum = 0,
          i,
          mod,
          deltaIndex,
          delta = [0, 1, 2, 3, 4, -4, -3, -2, -1, 0];

      for (i = 0; i < str.length; i++) {
        sum += parseInt(str.substring(i, i + 1));
      }

      for (i = str.length - 1; i >= 0; i -= 2) {
        deltaIndex = parseInt(str.substring(i, i + 1));
        sum += delta[deltaIndex];
      }

      mod = 10 - sum % 10;

      if (mod === 10) {
        mod = 0;
      }

      return mod;
    }
    /**
     * add ' ' every [num] digits
     * @param {string} str
     * @param {string} splitter
     * @return {string}
     * @private
     */

  }, {
    key: "_addSplitter",
    value: function _addSplitter(str, splitter) {
      var arr = [];

      while (str.length) {
        if (str.length > this.countBeforeSplitter) {
          arr.push(str.substring(0, this.countBeforeSplitter));
          str = str.substring(this.countBeforeSplitter);
        } else {
          arr.push(str.substring(0, str.length));
          str = '';
        }
      }

      return arr.join(splitter);
    }
  }]);
  return IAccount;
}();

var _default = IAccount;
exports["default"] = _default;